import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../app/store';

interface UserState {
  imageToken: string | null;
}

const initialState: UserState = {
  imageToken: null,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setImageToken: (state, action: PayloadAction<string | null>) => {
      state.imageToken = action.payload;
    },
  },
});

export const { setImageToken } = userSlice.actions;

export const selectImageToken = (state: RootState) => state.user.imageToken;

export default userSlice.reducer;
